import { getConfig } from '@configs/envConfig'
import { ApiFilterResponse } from '@interfaces/ackoDrive'
import { errorWithStack } from '@utils/logger'

const config = process.env.ACKO_ENV || 'prod'
const baseURL = `${getConfig(config)?.catalogServiceUrl}`

export const filterService = {
  getFilters: async (collectionSlug?: string): Promise<ApiFilterResponse | null> => {
    try {
      const queryParams = new URLSearchParams()

      if (collectionSlug) {
        queryParams.append('slug', collectionSlug)
      }

      const apiUrl = `${baseURL}/v1/filters/?${queryParams.toString()}`

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`Filter API HTTP error! Status: ${response.status}`)
      }

      const data = await response.json()

      return data
    } catch (error) {
      errorWithStack('Error fetching filter options from API:', error)
      return null
    }
  },
}
